// Errors and tracing only. No session replay.
import * as Sentry from '@sentry/react';

const environment = import.meta.env.APP_ENV ?? 'local';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment,
  // Sentry v11 replaced sendDefaultPii with dataCollection, which collects a lot
  // by default. Everything personal is off: the equivalent of sendDefaultPii: false.
  dataCollection: {
    userInfo: false,
    cookies: false,
    httpHeaders: false,
    httpBodies: [],
    urlQueryParams: false,
    stackFrameVariables: false,
  },
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: environment === 'production' ? 0.2 : 1.0,
  tracePropagationTargets: [/^\//],
});
